import { render, staticRenderFns } from "./UserChip.vue?vue&type=template&id=67c65ecb&web=true&"
import script from "./UserChip.vue?vue&type=script&lang=ts&"
export * from "./UserChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAvatar,VChip})
